import {relativeTime} from './relativeTime';

const TIME_FMT = new Intl.DateTimeFormat('en-GB', {
	hour: '2-digit',
	minute: '2-digit',
	hour12: false,
});

/**
 * The queue's Created column. Recent arrivals are the ones an agent triages, so
 * they read precisely; older ones collapse to an age:
 *
 * - today → `today 09:14`
 * - yesterday → `yesterday`
 * - older → `2d ago`, `1w ago`, … (see {@link relativeTime})
 *
 * Returns an em-dash for a missing or unparseable timestamp.
 */
export function formatCreated(isoDate: string | null | undefined, now: Date = new Date()): string {
	if (!isoDate) return '—';
	const created = new Date(isoDate);
	if (isNaN(created.getTime())) return '—';

	if (created.toDateString() === now.toDateString()) {
		return `today ${TIME_FMT.format(created)}`;
	}

	const yesterday = new Date(now);
	yesterday.setDate(yesterday.getDate() - 1);
	if (created.toDateString() === yesterday.toDateString()) {
		return 'yesterday';
	}

	return relativeTime(isoDate, now);
}
